import { useEffect, createRef, useState, ReactElement } from 'react'
import styled from 'styled-components'
import SVGSlider from './SVGSlider'
import HintAnimation from './HintAnimation'

import { calculateUsableDimensions } from '../utils'
import Placeholder from './Placeholder'
interface WrapperProps {
  height: string
  width: string
}
/*
  The Wrapper is the maximum possible size the widget can use
*/
const Wrapper = styled.div`
  position: relative;
  width: ${(props: WrapperProps) => props.width};
  height: ${(props: WrapperProps) => props.height};
  background-color: #ffffff;
  margin: 0 auto;
`

interface ImageProps {
  width: string
}

const Img = styled.img`
  width: ${(props: ImageProps) => props.width};
  position: absolute;
`

const Preview = styled.div`
  height: 100%;
  width: 100%;
`

interface TryOnProps {
  data: any
  height: number
  width: number
  aspectRatio: number
  sku?: string
  slideFull: string
}

const TryOn = ({
  height,
  width,
  data,
  aspectRatio,
  sku,
  slideFull
}: TryOnProps): ReactElement => {
  const getInitialIndex = (): number => {
    return data.indexOf(data.find((element: any) => element.pose === 0))
  }

  const [index] = useState(getInitialIndex())
  const [loading, setLoading] = useState(true)
  const [firstImageloading, setFirstImageLoading] = useState(true)
  const imageRef = createRef<HTMLImageElement>()

  const { url } = data[index]

  const asset = {}

  useEffect(() => {
    setFirstImageLoading(true)
    const img = new Image()
    img.src = data[0].url
    img.onload = () => {
      setFirstImageLoading(false)
    };
  }, [data])

  useEffect(() => {
    setLoading(true)
    for (let i = 1; i < data.length; i++) {
      const img = new Image()
      img.src = data[i].url
      img.onload = () => {
        if (i === data.length - 1) {
          setLoading(false)
        }
      }
    }
  }, [data])

  const handleUnwantedDrag = (e: any): void => {
    e.preventDefault()
  }

  const handleSliderChange = (percentage: number): void => {
    const i = Math.round((data.length - 1) * (percentage / 100))
    const currentResource = data[i]
    const currentImage = imageRef.current

    if (Boolean(currentResource) && currentImage !== null) {
      currentImage.src = currentResource.url
    }
  }

  const { usableHeight, usableWidth } = calculateUsableDimensions(height, width, aspectRatio)

  if (firstImageloading) {
    return (
      <Placeholder
        width={usableWidth}
        height={usableHeight}
        loading={true}
      >
        &nbsp;
      </Placeholder>
    )
  }

  return (
    <Wrapper width={`${usableWidth}px`} height={`${usableHeight}px`} className='topology-preview-wrapper'>
      <HintAnimation></HintAnimation>
      {asset !== undefined && (
        <Preview className='topology-preview'>
          <Img onDragStart={handleUnwantedDrag} alt='pose' ref={imageRef} width={`${usableWidth}`} src={url} key={index} className='topology-preview-image' />
          {loading === false && (
            <SVGSlider slideFull={slideFull} key={sku} usableWidth={usableWidth * 0.8} className='topology-slider' onChange={handleSliderChange} />
          )}
        </Preview>
      )}
      {asset === undefined &&
        <div>undfined asset</div>
      }
    </Wrapper>
  )
}

export default TryOn
